import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 62.3 249.5"},
  viewBox: "0 0 62.3 249.5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M62 115.4C33.6 94 31.1 64.5 31.1 64.5S28.7 94 .3 115.4M31.1 64.5v185",
  class: "i1604227350__st0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }